import { __assign } from "tslib";
import { createFocusOutlineStyle, makeStyles, shorthands, tokens, } from '@fluentui/react-components';
import { AppBarWide, FlyoutTileHeight, FlyoutTileHeightMaxWidth480, FlyoutTileWidth, FlyoutTileWidthMaxWidth480, TileDimensionDefault, TileHeightWide, TileMarginDefault, } from './Constants';
export var useLaunchTileStyles = makeStyles({
    tileFocusIndicator: createFocusOutlineStyle({
        selector: 'focus',
        style: {
            outlineWidth: '2px',
            outlineOffset: '-2px',
            outlineColor: tokens.colorStrokeFocus2,
        },
    }),
    tileContainer: {
        position: 'relative',
    },
    micaTileContainerV2Desktop: {
        position: 'relative',
    },
    flyoutTileContainer: {
        position: 'relative',
    },
    button: __assign(__assign(__assign({}, shorthands.borderWidth(0)), shorthands.padding('1px')), { minWidth: TileDimensionDefault, maxWidth: TileDimensionDefault, height: TileDimensionDefault, width: TileDimensionDefault, marginTop: TileMarginDefault, marginBottom: TileMarginDefault, fontWeight: tokens.fontWeightRegular, backgroundColor: tokens.colorSubtleBackground, userSelect: 'none', touchAction: 'none' }),
    buttonCommon: {
        ':hover': {
            boxShadow: 'none',
        },
        ':focus-visible': {
            boxShadow: 'none',
        },
    },
    buttonCommonTwoColumnView: {
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground4Selected,
        },
    },
    buttonCommonThreeColumnView: {
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground5Selected,
        },
    },
    micaButtonV2Web: {
        '&:hover': __assign(__assign({ backgroundColor: tokens.colorNeutralBackground5Hover, boxShadow: 'none' }, shorthands.borderColor('transparent')), { '& div': {
                '& > svg': {
                    fill: tokens.colorNeutralForeground3BrandHover,
                },
            } }),
        '&:active:hover': __assign(__assign({ backgroundColor: tokens.colorNeutralBackground5Pressed }, shorthands.borderColor('transparent')), { '& div': {
                '& > svg': {
                    fill: tokens.colorNeutralForeground3BrandPressed,
                },
            } }),
        ':focus-visible': __assign({ boxShadow: 'none' }, shorthands.borderColor('transparent')),
    },
    micaButtonV2Desktop: {
        '&:hover': __assign(__assign({ backgroundColor: tokens.colorSubtleBackgroundLightAlphaHover, boxShadow: 'none' }, shorthands.borderColor('transparent')), { '& div': {
                '& > svg': {
                    fill: tokens.colorNeutralForeground3BrandHover,
                },
            } }),
        '&:active:hover': __assign(__assign({ backgroundColor: tokens.colorSubtleBackgroundLightAlphaPressed }, shorthands.borderColor('transparent')), { '& div': {
                '& > svg': {
                    fill: tokens.colorNeutralForeground3BrandPressed,
                },
            } }),
        ':focus-visible': __assign({ boxShadow: 'none' }, shorthands.borderColor('transparent')),
    },
    selected: {
        backgroundColor: tokens.colorTransparentBackgroundSelected,
    },
    micaSelectedV2Web: {
        backgroundColor: tokens.colorTransparentBackgroundSelected,
    },
    micaSelectedV2Desktop: {
        backgroundColor: tokens.colorSubtleBackgroundLightAlphaSelected,
    },
    wideButton: __assign({ minWidth: AppBarWide, maxWidth: AppBarWide, width: AppBarWide, height: TileHeightWide, minHeight: TileHeightWide, marginTop: 0, marginBottom: 0 }, shorthands.borderRadius(0)),
    flyoutTile: __assign(__assign({ minWidth: FlyoutTileWidth, maxWidth: FlyoutTileWidth, minHeight: FlyoutTileHeight }, shorthands.borderRadius('6px')), { ':hover': {
            backgroundColor: tokens.colorNeutralBackground4Selected,
            boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.07), 0px 1.6px 3.6px rgba(0, 0, 0, 0.11)',
        }, ':focus-visible': {
            boxShadow: '0px 0.15px 0.45px rgba(0, 0, 0, 0.11), 0px 0.8px 1.8px rgba(0, 0, 0, 0.13)',
        }, '&:active:hover': {
            backgroundColor: tokens.colorNeutralBackground4Selected,
            boxShadow: '0px 0.15px 0.45px rgba(0, 0, 0, 0.11), 0px 0.8px 1.8px rgba(0, 0, 0, 0.13)',
        }, '@media (max-width: 480px)': {
            minWidth: FlyoutTileWidthMaxWidth480,
            maxWidth: FlyoutTileWidthMaxWidth480,
            minHeight: FlyoutTileHeightMaxWidth480,
        } }),
    transparentBackground: {
        backgroundColor: tokens.colorTransparentBackground,
    },
    badgeClip: {
        /**
         * A transparent AppBar uses a square with circle cutout clip path for any tiles that display a badge.
         * This allows the background between the badge and button icon to show instead of a solid tokensd color
         */
        clipPath: "path('m 0,0 c 0,28.3 0,56.5 0,85 22.7,0 45.3,0 68,0 0,-28.3 0,-56.6 0,-85 C 45.3,0 22.7,0 0,0 Z m 44,5 c 10,-0.5 10.7,16.4 0,16 -10.5,0.1 -10.5,-16 0,-16 z')",
    },
    badgeClipRtl: {
        /**
         * The RTL version of the clip path.
         */
        clipPath: "path('m 68,0 c 0,28.3 0,56.5 0,85 C 45.3,85 22.7,85 0,85 0,56.7 0,28.4 0,0 22.7,0 45.3,0 68,0 Z M 24,5 C 14,4.5 13.3,21.4 24,21 34.5,21.1 34.5,5 24,5 Z')",
    },
    dragging: {
        opacity: 0.5,
        marginLeft: '2px',
        zIndex: 100,
    },
});
//# sourceMappingURL=LaunchTile.styles.js.map